/**
 * Slick Slider Integration for Shopify Themes
 * Extracted from Lutava-PH-Optimizations theme
 * 
 * Dependencies:
 * - jQuery
 * - Slick Slider library
 * - CSS: slick slider styles
 */

(function($) {
  'use strict';

  // Icon definitions for navigation
  var icons = {
    chevronLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left ltr-icon"><title>Previous</title><polyline points="15 18 9 12 15 6"></polyline></svg>',
    chevronRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right ltr-icon"><title>Next</title><polyline points="9 18 15 12 9 6"></polyline></svg>'
  };

  // String translations (can be customized)
  var strings = {
    previous: 'Previous',
    next: 'Next'
  };

  // ========================================
  // SLICK SLIDER MANAGER
  // ========================================
  
  var SlickSliderManager = {
    
    // Testimonials slider configuration
    initTestimonials: function(container) {
      var $testimonialContainer = $('.testimonial-list', container);
      
      $testimonialContainer.find('.testimonial-list__inner').on('init', function () {
        $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
      }).slick({
        fade: $testimonialContainer.hasClass('testimonial-list--with-images'),
        slidesToShow: 1,
        autoplay: $testimonialContainer.data('autoplay'),
        autoplaySpeed: $testimonialContainer.data('autoplay-speed'),
        dots: false,
        arrows: true,
        appendArrows: $testimonialContainer.find('.testimonial-list__controls'),
        prevArrow: '<button type="button" class="slick-prev" aria-label="' + strings.previous + '">' + icons.chevronLeft + '</button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="' + strings.next + '">' + icons.chevronRight + '</button>',
        rtl: document.querySelector('html[dir=rtl]') ? true : false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              fade: false,
              slidesToShow: 1
            }
          }
        ]
      });
    },

    // Gallery subcollection slider configuration
    initGallerySubcollection: function(container) {
      var $subcollectionGallery = $('.subcollection-links--gallery .gallery', container);
      
      $subcollectionGallery.on('init', function () {
        $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
      }).slick({
        autoplay: false,
        fade: false,
        infinite: false,
        swipeToSlide: true,
        slidesToShow: Math.min(4, $('.subcollection-links--gallery .gallery__item', container).length),
        slidesToScroll: 1,
        useTransform: true,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="image-page-button image-page-button--previous ltr-icon" aria-label="' + strings.previous + '">' + icons.chevronLeft + '</button>',
        nextArrow: '<button type="button" class="image-page-button image-page-button--next ltr-icon" aria-label="' + strings.next + '">' + icons.chevronRight + '</button>',
        rtl: document.querySelector('html[dir=rtl]') ? true : false,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: Math.min(3, $('.subcollection-links--gallery .gallery__item', container).length)
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    },

    // Product gallery carousel configuration
    initProductGalleryCarousel: function(container) {
      var $carouselGallery = $('.gallery', container);
      
      $carouselGallery.on('init', function () {
        $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
      }).slick({
        autoplay: false,
        fade: false,
        infinite: true,
        useTransform: true,
        arrows: false,
        dots: true,
        customPaging: function customPaging(slider, i) {
          return "<button class=\"custom-dot\" type=\"button\" data-role=\"none\" role=\"button\" tabindex=\"0\">" + 
                 "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" width=\"30px\" height=\"30px\" viewBox=\"0 0 30 30\" xml:space=\"preserve\">" + 
                 "<circle class=\"circle-one\" cx=\"15\" cy=\"15\" r=\"13\" />" + 
                 "<circle class=\"circle-two\" cx=\"15\" cy=\"15\" r=\"13\" />" + 
                 "</svg>" + 
                 "</button>";
        },
        rtl: document.querySelector('html[dir=rtl]') ? true : false
      });
    },

    // Slideshow configuration
    initSlideshow: function(container, options) {
      var defaults = {
        autoplay: false,
        fade: true,
        speed: 500,
        autoplaySpeed: 5000,
        arrows: true,
        dots: true,
        pauseOnHover: false,
        infinite: true,
        useTransform: true
      };
      
      var config = $.extend({}, defaults, options);
      
      $(container).on('init', function () {
        $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
      }).slick({
        autoplay: config.autoplay,
        fade: config.fade,
        speed: config.speed,
        autoplaySpeed: config.autoplaySpeed,
        arrows: config.arrows,
        dots: config.dots,
        pauseOnHover: config.pauseOnHover,
        infinite: config.infinite,
        useTransform: config.useTransform,
        prevArrow: '<button type="button" class="slick-prev" aria-label="' + strings.previous + '">' + icons.chevronLeft + '</button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="' + strings.next + '">' + icons.chevronRight + '</button>',
        customPaging: function customPaging(slider, i) {
          var autoplaySpeed = config.autoplaySpeed || 5000;
          return "<button class=\"custom-dot\" type=\"button\" data-role=\"none\" role=\"button\" tabindex=\"0\">" + 
                 "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" width=\"30px\" height=\"30px\" viewBox=\"0 0 30 30\" xml:space=\"preserve\">" + 
                 "<circle class=\"circle-one\" cx=\"15\" cy=\"15\" r=\"13\" />" + 
                 "<circle class=\"circle-two\" cx=\"15\" cy=\"15\" r=\"13\" style=\"animation-duration: " + autoplaySpeed + "ms\" />" + 
                 "</svg>" + 
                 "</button>";
        },
        rtl: document.querySelector('html[dir=rtl]') ? true : false
      });
    },

    // Product slideshow configuration (for product galleries)
    initProductSlideshow: function(container, options) {
      var defaults = {
        autoplay: false,
        fade: false,
        infinite: false,
        swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        useTransform: true,
        arrows: true,
        dots: false
      };
      
      var config = $.extend({}, defaults, options);
      
      $(container).slick(config);
    },

    // Generic slider initialization
    initSlider: function(selector, options) {
      var defaults = {
        autoplay: false,
        fade: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        useTransform: true,
        rtl: document.querySelector('html[dir=rtl]') ? true : false
      };
      
      var config = $.extend({}, defaults, options);
      
      // Add default arrows if not provided
      if (config.arrows && !config.prevArrow) {
        config.prevArrow = '<button type="button" class="slick-prev" aria-label="' + strings.previous + '">' + icons.chevronLeft + '</button>';
      }
      if (config.arrows && !config.nextArrow) {
        config.nextArrow = '<button type="button" class="slick-next" aria-label="' + strings.next + '">' + icons.chevronRight + '</button>';
      }
      
      $(selector).slick(config);
    },

    // Destroy sliders
    destroySliders: function(container) {
      $('.slick-slider', container).each(function () {
        $(this).slick('unslick');
      });
    },

    // Refresh slider position
    refreshSliders: function(container) {
      $('.slick-slider', container).each(function () {
        $(this).slick('setPosition');
      });
    },

    // Go to specific slide
    goToSlide: function(container, slideIndex) {
      $('.slick-slider', container).each(function () {
        $(this).slick('slickGoTo', slideIndex);
      });
    },

    // Play/Pause autoplay
    playSlider: function(container) {
      $('.slick-slider', container).each(function () {
        $(this).slick('slickPlay');
      });
    },

    pauseSlider: function(container) {
      $('.slick-slider', container).each(function () {
        $(this).slick('slickPause');
      });
    },

    // Set slider options
    setOption: function(container, option, value) {
      $('.slick-slider', container).each(function () {
        $(this).slick('slickSetOption', option, value);
      });
    },

    // Get current slide
    getCurrentSlide: function(container) {
      var currentSlide = 0;
      $('.slick-slider', container).each(function () {
        var slick = $(this).slick('getSlick');
        currentSlide = slick.currentSlide;
      });
      return currentSlide;
    },

    // Get total slides
    getTotalSlides: function(container) {
      var totalSlides = 0;
      $('.slick-slider', container).each(function () {
        var slick = $(this).slick('getSlick');
        totalSlides = slick.slideCount;
      });
      return totalSlides;
    }
  };

  // ========================================
  // SECTION MANAGERS
  // ========================================

  // Testimonials Section Manager
  var TestimonialsSection = {
    onSectionLoad: function(container) {
      SlickSliderManager.initTestimonials(container);
    },

    onSectionUnload: function(container) {
      SlickSliderManager.destroySliders(container);
    },

    onBlockSelect: function(container, block) {
      var blockSlideIndex = $(block).data('slick-index');
      $(block).closest('.slick-slider').each(function () {
        $(this).slick('slickGoTo', blockSlideIndex);
      });
    }
  };

  // Gallery Section Manager
  var GallerySection = {
    onSectionLoad: function(container) {
      SlickSliderManager.initGallerySubcollection(container);
    },

    onSectionUnload: function(container) {
      SlickSliderManager.destroySliders(container);
    }
  };

  // Slideshow Section Manager
  var SlideshowSection = {
    onSectionLoad: function(container, options) {
      SlickSliderManager.initSlideshow(container, options);
    },

    onSectionUnload: function(container) {
      SlickSliderManager.destroySliders(container);
    }
  };

  // ========================================
  // UTILITY FUNCTIONS
  // ========================================

  // Lazy loading integration
  var initLazyLoading = function(container) {
    $('.slick-slider', container).on('init', function () {
      $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
    });
  };

  // Responsive breakpoint handler
  var handleResponsive = function(container) {
    $(window).on('resize', function() {
      SlickSliderManager.refreshSliders(container);
    });
  };

  // ========================================
  // EXPOSE GLOBALLY
  // ========================================

  // Expose main manager
  window.SlickSliderManager = SlickSliderManager;
  
  // Expose section managers
  window.TestimonialsSection = TestimonialsSection;
  window.GallerySection = GallerySection;
  window.SlideshowSection = SlideshowSection;

  // Expose utility functions
  window.SlickSliderUtils = {
    initLazyLoading: initLazyLoading,
    handleResponsive: handleResponsive,
    icons: icons,
    strings: strings
  };

  // ========================================
  // AUTO-INITIALIZATION
  // ========================================

  // Auto-initialize on document ready
  $(document).ready(function() {
    // Initialize testimonials
    SlickSliderManager.initTestimonials(document);
    
    // Initialize gallery subcollections
    SlickSliderManager.initGallerySubcollection(document);
    
    // Initialize lazy loading
    initLazyLoading(document);
    
    // Handle responsive behavior
    handleResponsive(document);
    
    // Re-initialize on section load (for Shopify sections)
    $(document).on('shopify:section:load', function(event) {
      SlickSliderManager.initTestimonials(event.target);
      SlickSliderManager.initGallerySubcollection(event.target);
      initLazyLoading(event.target);
    });
    
    // Clean up on section unload
    $(document).on('shopify:section:unload', function(event) {
      SlickSliderManager.destroySliders(event.target);
    });
  });

  // ========================================
  // USAGE EXAMPLES
  // ========================================

  /*
  // Basic slider
  SlickSliderManager.initSlider('.my-slider', {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    arrows: true
  });

  // Testimonials slider
  SlickSliderManager.initTestimonials('#testimonials-section');

  // Gallery slider
  SlickSliderManager.initGallerySubcollection('#gallery-section');

  // Custom slideshow
  SlickSliderManager.initSlideshow('.slideshow', {
    autoplay: true,
    fade: true,
    autoplaySpeed: 5000,
    arrows: true,
    dots: true
  });

  // Destroy sliders
  SlickSliderManager.destroySliders('#container');

  // Go to specific slide
  SlickSliderManager.goToSlide('#container', 2);

  // Play/Pause
  SlickSliderManager.playSlider('#container');
  SlickSliderManager.pauseSlider('#container');

  // Set options
  SlickSliderManager.setOption('#container', 'autoplay', true);
  */

})(jQuery);
